import { render, staticRenderFns } from "./PostDetailView.vue?vue&type=template&id=ede06f34&scoped=true&"
import script from "./PostDetailView.vue?vue&type=script&lang=js&"
export * from "./PostDetailView.vue?vue&type=script&lang=js&"
import style0 from "./PostDetailView.vue?vue&type=style&index=0&id=ede06f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede06f34",
  null
  
)

export default component.exports